export default {
  queryAuthority: '/auth/authority/request/query',
}



// WEBPACK FOOTER //
// ./src/api/mineApply.js